<template>
  <div class="d-flex justify-content-center" >
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-card class="cardSe" style="width: 95%">
        <b-row>
          <b-col :class="cardAbierto === true ? 'tituloCard seleccionado' : 'tituloCard' " class="text-left d-flex align-items-center">
            Listado de hallazgos adicionales
          </b-col>
          <b-col>
            <span style="color: #EDAC23; font-size: 10px; font-weight: 600;"
                  v-show="cardAbierto === true && modoEdicion"
            >Modo Edicion Activo</span>
          </b-col>
          <b-col class="text-right">

            <em v-if="!modoEdicion && cardAbierto && hallazgosAdicionales.length > 0 " class="editarV5"
                :style= '!bloquearByProceso ? "margin-bottom: -5px; cursor: pointer" : "margin-bottom: -5px;" '
                v-b-tooltip.hover.top.v-light
                title="Activar modo Edición"
                @click="activarEdicion(true)"
                :disabled="bloquearByProceso"
            ></em>
            <em v-if="modoEdicion && cardAbierto"
                class="penEdicion_svg"
                style="margin-bottom: -5px; cursor: pointer"
                v-b-tooltip.hover.top.v-light
                title="Desactivar modo Edición"
                @click="activarEdicion(false)"
            ></em>
            <b-button variant="ligth" size="sm" pill v-b-toggle="'collapseDetail-hallazgo'" @click="abrirCard() ">
              <b-icon v-show="cardAbierto"
                      style="color: #4FB0B7;  font-size: 10px; height: 14px; "
                      icon="chevron-up"
              ></b-icon>
              <b-icon v-show="!cardAbierto"
                      style="color: #4FB0B7;  font-size: 10px; height: 14px; "
                      icon="chevron-down"
              ></b-icon>
            </b-button>
          </b-col>
        </b-row>

        <b-collapse id="collapseDetail-hallazgo"
                    role="tabpanel" ref="collapse-hallazgo">
          <div v-for="(hallazgo, index) in hallazgosAdicionales" :key="index">
            <b-card class="text-left" style="border: 0px;">

          <span v-if="!agrupadoPorOD" style="font-size: 11px; color: #79ACCE">
            <em class="dienteTratamiento"></em>
            {{hallazgo.nombreTratamiento}}
            <em v-if="modoEdicion && hallazgo.listPadecimientos.some(ls => ls.estatus === 0)" class="trash_svg" style=" width: 17px; padding-right: 2px; cursor: pointer"
                v-b-tooltip.hover.top.v-light
                title="Eliminar registros"
                @click="pasarEstatusEliminadoTxs(hallazgo.listPadecimientos)"/>
            <em v-if="modoEdicion && hallazgo.listPadecimientos.every(ls => ls.estatus === 2)" class="close_red" style=" width: 17px; padding-right: 2px; cursor: pointer"
                v-b-tooltip.hover.top.v-light
                title="Cancelar eliminación grupal"
                @click="quitarEstatusEliminadoTxs(hallazgo.listPadecimientos)"/>
          </span>
              <span v-else style="font-size: 11px; color: #79ACCE">
            <em class="dienteTratamiento"></em>
            {{hallazgo.diente}}
          </span>
              <b-row class="m-0 bold">
                <b-col v-if="!agrupadoPorOD" class="leterSize text-left p-0 columnas-col" style="width: 10%; border-right: #ECECEC 1px solid;">
                  Od´s afectados
                </b-col>
                <b-col v-else class="leterSize text-left p-0 columnas-col" style="width: 12%; border-right: #ECECEC 1px solid;">Tratamiento</b-col>
                <b-col class="leterSize bordeTable text-left p-1 columnas-col">Padecimiento</b-col>
                <b-col class="leterSize bordeTable p-0 text-center columnas-col">Cantidad tratamiento</b-col>
                <b-col class="leterSize bordeTable p-0 text-center columnas-col" >Precio unitario</b-col>
                <b-col class="leterSize bordeTable p-0 text-center columnas-col" v-if="modoEdicion">Acciones</b-col>
              </b-row>

              <div v-for="(pad, ind1) in hallazgo.listPadecimientos" :key="'init-'+ind1">
                <b-row class="m-0">
                  <b-col v-if="!agrupadoPorOD" class="leterSize text-center p-0 columnas-col" style="border-right: 1px solid #ECECEC">
                    <b-button size="sm" variant="outline-info" pill disabled>
                      <span style="color: #FFFFFF">....</span>
                      <span class="leterSize">{{pad.numeroDiente}}</span>
                      <span style="color: #FFFFFF">....</span>
                    </b-button>
                  </b-col>
                  <b-col v-else class="leterSize text-center p-0 columnas-col" style="border-right: 1px solid #ECECEC">
                    <b-button size="sm" variant="outline-info" pill disabled class="ml-2 mr-2">
                      <span class="leterSize">{{pad.tratamiento}}</span>
                    </b-button>
                  </b-col>
                  <b-col class="leterSize bordeTable text-left p-1 d-flex align-items-center border-estatus-inicio" :style="pad.estilos">
                    {{pad.nombrePadecimiento}}
                  </b-col>
                  <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-medio" :style="pad.estilos">
                    {{pad.cantidad}}
                  </b-col>
                  <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-medio" :style="pad.estilos">
                    {{pad.precioUnitario | moneda}}
                  </b-col>
                  <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-final" v-if="modoEdicion" :style="pad.estilos">
                    <em v-if="modoEdicion && pad.estatus === 0" class="flechaVerde_svg"
                        style=" width: 17px; padding-right: 2px; cursor: pointer"
                        v-b-tooltip.hover.top.v-light
                        title="Pasar a Presentar"
                        @click="pasarAPresentar(pad, hallazgo.nombreTratamiento)"
                    />
                    <em v-if="modoEdicion && pad.estatus === 1" class="flechaAtras_svg"
                        style=" width: 17px; padding-right: 2px; cursor: pointer"
                        v-b-tooltip.hover.top.v-light
                        title="retirar de tratamientos a presentar"
                        @click="quitarDePresentar(pad, hallazgo.nombreTratamiento)"
                    />


                    <em v-if="modoEdicion && pad.estatus != 1 && pad.estatus != 2" class="trash_svg"
                        style=" width: 17px; padding-right: 2px; cursor: pointer"
                        v-b-tooltip.hover.top.v-light
                        title="Eliminar registro"
                        @click="pasarEstatusEliminadoTx(pad)"/>

                    <em v-if="modoEdicion && pad.estatus == 2" class="close_red"
                        style=" width: 17px; padding-right: 2px; cursor: pointer"
                        v-b-tooltip.hover.top.v-light
                        title="Cancelar eliminación"
                        @click="quitarEstatusEliminadoTx(pad)"/>
                  </b-col>
                </b-row>
                <hr v-if="hallazgo.listPadecimientos.length !== 1 && hallazgo.listPadecimientos.length !== ind1 + 1"
                    class="mt-2 mb-2">
              </div>
            </b-card>
          </div>
        </b-collapse>
      </b-card>
  </div>
</template>

<script>
export default {
  name: "HallazgosEdicion",
  props: {
    hallazgosAdicionales: Array,
    agrupadoPorOD: Boolean,
    bloquearByProceso: Boolean,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    cardSeleccionado: false,
    cardAbierto: false,
    modoEdicion: false
  }),
  watch: {
    agrupadoPorOD() {
      this.$refs["collapse-hallazgo"].show = false;
      this.cardAbierto = false;
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    activarEdicionDesdePrioridad(estado){
      this.modoEdicion = estado;
    },
    activarEdicion(estado){
      if (!this.bloquearByProceso){
        this.$emit("activarEdicion", estado)
        this.modoEdicion = estado;
      }
    },
    abrirCard(){
      this.cardSeleccionado = true;
      this.cardAbierto = !this.cardAbierto;
    },
    quitarDePresentar(item){
      item.estatus = 0;
      this.cambiarEstiloColumna(item, item.estatus)
    },
    pasarAPresentar(item, nombre){
      item.estatus = 1;
      this.cambiarEstiloColumna(item, item.estatus)
      this.$emit("llenarTratamientosPresentar", item, nombre)
    },
    pasarEstatusEliminadoTx(item) {
      item.estatus = 2;
      this.cambiarEstiloColumna(item, item.estatus)
    },
    quitarEstatusEliminadoTx(item) {
      item.estatus = 0;
      this.cambiarEstiloColumna(item, item.estatus)
    },
    pasarEstatusEliminadoTxs(padecimientos) {
      padecimientos.forEach(p => {
        if (p.estatus === 0) {
          p.estatus = 2;
          this.cambiarEstiloColumna(p, p.estatus)
        }
      })
    },
    quitarEstatusEliminadoTxs(padecimientos) {
      padecimientos.forEach(p => {
        if (p.estatus === 2) {
          p.estatus = 0;
          p.estilos = 'border-color: white';
        }
      })
    },
    cambiarEstiloColumna(item, estatus) {
      if (estatus === 1) {
        item.estilos = 'border-color: #94d993';
      } else if (estatus === 2) {
        item.estilos = 'border-color: #ea707e';
      } else if (estatus === 3) {
        item.estilos = 'border-color: #81cdd8';
      } else if (estatus === 4) {
        item.estilos = 'border-color: #94d993';
      } else {
        item.estilos = 'border-color: white';
      }
    }
  }
}
</script>

<style scoped>
.cardSe {
  border: 1px solid #d6e7f3;
  border-radius: 16px;
}
.leterSize{
  font-size: 10px !important;
  color: #4F4F4F;
}
.bordeTable{
  border-bottom: #ECECEC 1px solid;
}
.tituloCard.seleccionado{
  font-weight: 600;
  font-size: 12px !important;
  color: #55C6B2;
}
.tituloCard{
  font-size: 10px !important;
  color: #717171;
}

.columnas-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.border-estatus-inicio {
  border-radius: 10px 0 0 10px;
  border-top: 1px solid;
  border-left: 1px solid;
  border-bottom: 1px solid
}

.border-estatus-medio {
  border-top: 1px solid;
  border-bottom: 1px solid
}

.border-estatus-final {
  border-radius: 0 10px 10px 0;
  border-top: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid
}
</style>